module.exports = __webpack_public_path__ + "img/visa.38ad35dc.svg";